'use strict';

var util = require('./util/util');

module.exports = {
    // 校验 url 规则
    checkUrl: function checkUrl(url) {
        var reg;

        return arrayCheck(url, function (_url) {
            if (util.isRegExp(_url)) {
                try {
                    reg = new RegExp(_url);
                    return reg.test(location.href);
                } catch (e) {
                    return false;
                }
            } else {
                return location.href.indexOf(_url) > -1;
            }
        });
    },

    // 校验 spm 规则
    checkSpm: function checkSpm(spm) {
        return arrayCheck(spm, function (_spm) {
            try {
                return window.MT.Tracker.getPageAB() == _spm;
            } catch (e) {
                return false;
            }
        });
    },

    // 校验 base 版本号规则
    checkBaseVersion: function checkBaseVersion(baseVersion) {
        return arrayCheck(baseVersion, function (_baseVersion) {
            return window.base && window.base.version == _baseVersion;
        });
    },

    // 校验项目版本号规则
    checkProjVersion: function checkProjVersion(projVersion) {
        var currentVersion = getProjVersion();

        return arrayCheck(projVersion, function (_projVersion) {
            return currentVersion && currentVersion == _projVersion;
        });
    },

    // 容器规则
    checkApp: function checkApp(app) {
        var currentApp = /AliApp\((.*?)\//.exec(window.navigator.userAgent);
        currentApp = currentApp && currentApp.length && currentApp[1] || 'H5';

        return arrayCheck(app, function (_app) {
            return currentApp == _app;
        });
    },

    // 平台规则
    checkOS: function checkOS(os) {
        var currentOS = window.Bridge.Global.platform;

        return arrayCheck(os, function (_os) {
            return currentOS == _os;
        });
    }

};

// 自动校验数组配置
function arrayCheck(config, checkFun) {
    var t = this;

    if (util.isArray(config)) {
        return config.some(function (item) {
            return checkFun.call(t, item);
        });
    } else {
        return checkFun.call(t, config);
    }
}

// 获取项目版本号
function getProjVersion() {
    if (window.KISSY && KISSY.Config) {
        return KISSY.Config.version || "";
    } else {
        var meta = document.querySelector('meta[name="alitrip-project-version"]');
        var metaVal = meta && meta.getAttribute('content');
        return metaVal || "";
    }
}


/*****************
 ** WEBPACK FOOTER
 ** ./components/pipe/check.js
 ** module id = 13
 ** module chunks = 0
 **/